import React from "react"
import {Box} from "@mui/material"
import {UxCTA as CTA} from "@next/ux-cta"
import {StyledContainer} from "./component"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"

export const ClubCheckout = props => {
    const {enable} = props
    return (
        <StyledContainer data-testid="header-adaptive-checkout" className="header-adaptive-checkout">
            <Box display={{xs: "none", md: "block"}}>
                <CTA
                    {...props}
                    color="primary"
                    disabled={!enable}
                    state={enable ? "enabled" : "disabled"}
                    variant="contained"
                    size="medium"
                    rel="nofollow"
                    onClick={removeDeptFromSessionStorage}
                />
            </Box>
        </StyledContainer>
    )
}

export default ClubCheckout
